module.exports = __webpack_public_path__ + "img/43-r.14dd2168.png";